import dashboard from './dashboard';
import pacientes from './pacientes';
import utilities from './utilities';
import other from './other';
import consultorio from './consultorio';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, pacientes, consultorio]
};

export default menuItems;
